import { makeStyles } from '@material-ui/core';

import { neutral } from '../../../../shared/styles/colors';

export default makeStyles({
  button: ({ disabled = false }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1.25px solid ${neutral[20]}`,
    borderRadius: '0.5rem',
    padding: '0.5rem',
    backgroundColor: disabled ? neutral[30] : neutral.white,
    cursor: disabled ? 'not-allowed' : 'pointer',
    width: '2.5rem',
    height: '2.5rem',
  }),
  icon: ({ disabled = false }) => ({
    fontSize: '1.64rem',
    fontWeight: 600,
    color: disabled ? neutral[50] : neutral[80],
  }),
});
